"use client";

import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import Image from "next/image";
import Link from "next/link";

export function HeroSection() {
  const { isAuthenticated, login } = useAuth();

  return (
    <section className="relative w-full h-[95vh] overflow-hidden rounded-2xl">
      {/* Mobile Background */}
      <Image
        src="https://pulsarmoney.b-cdn.net/quests/campaigns/swapper-portal/hero-section-bg-mobile.png"
        alt="Swapper Portal"
        fill
        priority
        className="md:hidden object-cover"
        quality={100}
      />
      {/* Desktop Background */}
      <Image
        src="https://pulsarmoney.b-cdn.net/quests/campaigns/swapper-portal/hero-section-bg.png"
        alt="Swapper Portal"
        fill
        priority
        className="hidden md:block object-cover"
        quality={100}
      />

      <div className="relative z-10 flex flex-col items-center justify-center h-full px-6 text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4 md:mb-6 leading-tight">
          Swapper Portal
        </h1>

        <p className="text-lg md:text-xl text-white/90 mb-8 md:mb-10 max-w-2xl">
          From card, CEX, or wallet — directly into DeFi.
        </p>

        {isAuthenticated ? (
          <Link href="/quests">
            <Button
              className="bg-white hover:bg-white/90 text-swapper-primary px-8 md:px-10 py-3 md:py-4 rounded-xl text-base md:text-lg font-semibold transition-all duration-200 ease-out"
            >
              View Quests
            </Button>
          </Link>
        ) : (
          <Button
            onClick={login}
            className="bg-white hover:bg-white/90 text-swapper-primary px-8 md:px-10 py-3 md:py-4 rounded-xl text-base md:text-lg font-semibold transition-all duration-200 ease-out"
          >
            Log In
          </Button>
        )}
      </div>
    </section>
  );
}
